// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Set', { toJSON: require('./_collection-to-json')('Set') });



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.set.to-json.js
// module id = 1368
// module chunks = 168707334958949